import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IConfirm } from 'src/app/interfaces/confirm';
import { IError } from 'src/app/interfaces/error.interface';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { InvoiceService } from 'src/app/services/http/business/invoice/invoice.service';

@Component({
  selector: 'app-subsidiary-registration-invoice',
  templateUrl: './subsidiary-registration-invoice.component.html',
  styleUrls: ['./subsidiary-registration-invoice.component.css']
})
export class SubsidiaryRegistrationInvoiceComponent implements OnInit {
  invoicePrice: number;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  constructor(
    private invoiceService: InvoiceService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private errorService: ErrorsService,
    private snackBar: SnackBarService,
    private dialogRef: MatDialogRef<SubsidiaryRegistrationInvoiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    this.invoicePrice = this.data.invoice.Price;
  }

  onNoClick() {
    this.dialogRef.close();
  }

  submit() {
    if (this.invoicePrice > 0) {
      let confirm: IConfirm = {
        accept: true,
        message: 'آیا از صدور فاکتور ثبت نام اطمینان دارید؟',
        alert: null,
        yesLabel: this.translate.get("label.yes"),
        noLabel: this.translate.get("label.no")
      };
      this.dialog
        .open(ConfirmComponent, {
          width: "500px",
          data: confirm
        })
        .afterClosed()
        .subscribe(res => {
          if (res) {
            var data = {
              ContractId: this.data.contractId,
              InvoiceItemTypeCode: 'AghRegistration',
              Price: this.invoicePrice
            }
            this.errors = new Array();
            this.invoiceService.addAghInvoice(data).subscribe(
              () => {
                this.snackBar.OpenSnackBar(
                  'فاکتور ثبت نام با موفقیت صادر شد',
                  "ok",
                  5000,
                  SoundEnum.beep
                );
              },
              err => {
                // this.errObject = this.errorService.getError(err);
                // this.param = this.errorService.objectError(this.errObject);
                // this.errors = this.errorService.returnError(err);
                this.errorList = this.errorService.getErrorList(err.error);
              })
          }
        });
    }
    else {
      this.snackBar.OpenSnackBar(
        'لطفا مبلغ فاکتور را مشخص نمایید',
        "ok",
        5000,
        SoundEnum.beep
      );
    }
  }

}
